import { render, staticRenderFns } from "./AxShortcutDropdownButton.vue?vue&type=template&id=3ec85c7a&scoped=true&"
import script from "./AxShortcutDropdownButton.vue?vue&type=script&lang=ts&"
export * from "./AxShortcutDropdownButton.vue?vue&type=script&lang=ts&"
import style0 from "./AxShortcutDropdownButton.vue?vue&type=style&index=0&id=3ec85c7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec85c7a",
  null
  
)

export default component.exports